module.exports = __webpack_public_path__ + "static/media/white-check-icon.66b0b674.svg";